/**
 * @fileoverview ダウンロードページ
 */
import LinkList from "../components/LinkList";
import AtagButton from "../components/AtagButton";
import { useTranslation } from "react-i18next";

/**
 * ダウンロードページのコンポーネント
 * @returns {JSX.Element} ダウンロードページの JSX 要素
 */
export function Download(): JSX.Element {
  /**
   * 多言語対応用の t 関数
   */
  const { t } = useTranslation();

  /**
   * アナシスダウンロードのリンクリスト
   */
  const items_download = [
    {
      to: "/anasys/HowToDownLoadAndInstall",
      text: t("ダウンロードとインストールの手順"),
    },
  ];

  /**
   * デバイスドライバーのリンクリスト
   */
  const items_dvicedriver = [
    {
      to: "/anasys/HowToDownloadDeviceDriver",
      text: t("デバイスドライバーのダウンロード方法"),
    },
    {
      to: "/anasys/HowToInstallDeviceDriver",
      text: t("デバイスドライバーのインストール方法"),
    },
  ];

  return (
    <div>
      <section className="c-section">
        <h2 className="p-heading-2">{t("ダウンロード")}</h2>
        <h3 className="p-heading-3">
          {t("アナシスソフトウェア ダウンロード")}
        </h3>
        <p className="c-text">
          {t("アナシスソフトウェアをダウンロードできます。")}
          <br />
          {t(
            "下の[アナシスダウンロード]ボタンを押して、ダウンロードを開始してください。"
          )}
          <br />
          <p className="u-font-red">
            {t(
              "ダウンロード時に実行せずに一度ファイルをローカルに保存後インストールを実行してください。"
            )}
          </p>
        </p>
        <AtagButton
          href={t("アナシスインストーラーURL")}
          text={t("アナシス ダウンロード")}
        />

        <LinkList items={items_download} />

        <h3 className="p-heading-3">{t("アナシスソフトウェア 取扱説明書")}</h3>
        <p className="c-text">
          {t("アナシスソフトウェアの取扱説明書をダウンロードできます。")}
          {t("ファイル形式はPDFです。")}
          {t(
            "下の[アナシス取扱説明書(PDF)]ボタンを押して、ダウンロードを開始してください。"
          )}
          <br />
        </p>
        <AtagButton
          href={t("アナシス取扱説明書URL")}
          text={t("アナシス取扱説明書(PDF)")}
        />

        <h3 className="p-heading-3">{t("デバイスドライバー ダウンロード")}</h3>
        <p className="c-text">
          {t(
            "GHS-8AT用USBドライバをダウンロードできます。ファイルは圧縮されています。"
          )}
          <br />
          {t(
            "下の[GHS-8ATデバイスドライバー]ボタンを押してダウンロードを開始してください。"
          )}
        </p>
        <AtagButton
          href="https://gastec-public-soft-download.s3.ap-northeast-1.amazonaws.com/anasys/usb-drivers/v2.12.36.4_G/USBDrivers.zip"
          text={t("GHS-8AT デバイスドライバー")}
        />

        <LinkList items={items_dvicedriver} />
      </section>
    </div>
  );
}
